import PropTypes from 'prop-types';

import Cell from './Cell';

const Row = ({ time, cells, style }) => {
  return (
    <div className="relative h-10 overflow-hidden bg-[#F7F7F7] " style={style}>
      {(cells ?? [])?.map((cell) => (
        <Cell key={cell.id} time={time} {...cell} />
      ))}
    </div>
  );
};

Row.propTypes = {
  time: PropTypes.shape({}).isRequired,
  cells: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  style: PropTypes.shape({}),
};

export default Row;
